export interface RestrictDurationCheckEvent {
  uid: string;
  parentEventId: number | null;
  isParent: boolean;
  isSeminar: boolean;
  startedAt: number;
  endedAt: number;
}

export interface RestrictCountCheckEvent {
  uid: string;
  email: string;
  isParent: boolean;
  startedAt: number;
  endedAt: number;
}

export default class EventTypeRestrictValidator {
  static isEventDurationExceeded(
    limit: number,
    targetStartedAt: number,
    targetEndedAt: number,
    timeMin: number,
    timeMax: number,
    events: RestrictDurationCheckEvent[],
    editingEventUid: string | null,
  ) {
    const addDuration = (targetEndedAt - targetStartedAt) / 60;
    if (limit < addDuration) {
      return true;
    }
    let totalDuration = 0;

    const parentEventIds: number[] = [];
    for (const event of events) {
      if (
        event.isParent ||
        (editingEventUid && editingEventUid === event.uid)
      ) {
        continue;
      }
      const parentEventId = event.parentEventId;
      const isSeminar = event.isSeminar;
      const startedAt = event.startedAt;
      const endedAt = event.endedAt;
      // すでに加算済みのセミナー予約は加算しない
      if (parentEventId) {
        if (parentEventIds.includes(parentEventId)) {
          continue;
        }
        parentEventIds.push(parentEventId);
      }
      // 既存のセミナー予約へ追加予約する場合は予約可能にする
      if (
        isSeminar &&
        targetStartedAt === startedAt &&
        targetEndedAt === endedAt
      ) {
        return false;
      }
      if (startedAt <= timeMax && endedAt >= timeMin) {
        const duration = (endedAt - startedAt) / 60;
        totalDuration += duration;
      }
      if (limit < totalDuration + addDuration) {
        return true;
      }
    }

    return false;
  }

  static isEventCountExceeded(
    limit: number,
    email: string,
    timeMin: number,
    timeMax: number,
    events: RestrictCountCheckEvent[],
    editingEventUid: string | null,
  ) {
    const addCount = 1;
    let totalCount = 0;
    for (const event of events) {
      if (
        event.isParent ||
        (editingEventUid && editingEventUid === event.uid)
      ) {
        continue;
      }
      const contactEmail = event.email;
      const startedAt = event.startedAt;
      const endedAt = event.endedAt;
      if (
        contactEmail === email &&
        startedAt <= timeMax &&
        endedAt >= timeMin
      ) {
        totalCount += 1;
      }
      if (limit < totalCount + addCount) {
        return true;
      }
    }

    return false;
  }
}
